import { Component, OnInit } from '@angular/core';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

import { OpEnum } from '../../../shared/enums/op.enum';
import { CityModel, EthnicGroupModel } from '../../../shared/models/abre-cuentas.model';
import { ContactModel } from 'src/app/shared/models/contact.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { BUSINESS_CONST } from '../../../shared/constants/business.constants';
import { getAppStatus } from 'single-spa';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-residence-abroad',
  templateUrl: './residence-abroad.component.html',
  styleUrls: ['./residence-abroad.component.scss'],
})
export class ResidenceAbroadComponent implements OnInit {

  options: any[];
  optionss: any[];
  selectedCity: CityModel;
  selectedEthnicGroup: EthnicGroupModel;
  isPostLogin: boolean;
  checkboxList: any;
  emptyCity: CityModel = new CityModel();
  contactInfo: any;
  multiLines = true;
  district_option: any;
  selected_district: any;
  city_option: any;
  city_selected: any;
  enabledButton = true;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private captureService: CaptureService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private bioCatchService: BioCatchService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private taggingService: TaggingService,
    private helperService: HelpersService,
    private requestService: RequestService) {
    this.headerService.show(true, true, true);

    this.checkboxList = [
      {
        id: 'checkbox1',
        label: this.copyService.copies.residence_abroad_copies.radio_button_text_yes,
        value: '1',
        checked: false,
      },
      {
        id: 'checkbox2',
        label: this.copyService.copies.residence_abroad_copies.radio_button_text_no,
        value: '2',
        checked: true,
      },
    ];
    this.district_option = this.abreCuentasService.getDistricts();
  }

  ngOnInit() {
    this.initBioCatch();
    /* istanbul ignore else */
    if (this.abreCuentasService.getLiveAbroad().elementId === 1) {
      this.checkboxList[0].checked = true;
      this.checkboxList[1].checked = false;
    }

    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    if (product === ProductsBiocatchEnum.AHO || product === ProductsBiocatchEnum.NOM) {
      this.bioCatchService.changeContext(StepBiocatchEnum.captura, product, false, true);
    }
    // TODO: SETEO DE DATOS
    // this.abreCuentasService.setProspectResponse({ client: false });
    const status = getAppStatus('evidente');
    status === 'MOUNTED' ? this.helperService.unRegisterAplication('evidente') : console.log();

    // this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
    const selectedCity = this.abreCuentasService.getBirthplaceInfo();
    if (!!selectedCity && selectedCity.city_code) {
      this.selectedCity = this.abreCuentasService.getBirthplaceInfo();
      this.selected_district = this.selectedCity.district_id;
    } else {
      this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
    }
    this.isPostLogin = this.abreCuentasService.getPostlogin();
    if (!this.isPostLogin) {
      this.optionss = this.parametersService.getSetting(OpEnum.ETHNIC_GROUP);
    }
    // SI NO ES CLIENTE SE HACE SETEO DE DATOS QUE LLEGAN DE EVIDENTE MASTER
    /* istanbul ignore else */
    if (!this.abreCuentasService.getProspectResponse().client && this.channelCommunicatorService.getChannelId() !== '141') {
      this.setContactInfo(this.abreCuentasService.getDocumentInfo());
    }
    this.selectedEthnicGroup = { ethnic_group_code: 0, ethnic_group_description: '' };
    this.enableButton();
  }

  /**
   * Summary Go to next Step
   */
  next() {
    this.sendTagging('next', 'bottom', '2');
    if (this.abreCuentasService.getLiveAbroad().elementId === 1) {
      this.abreCuentasService.caseInfoError('301');
      this.navigationService.nextStep('301');
      this.navigationService.pageLoadTag('ErrorResidenciaExterior', ['pv39', 'pv191', 'pv169', '']);
      return;
    }

    this.captureService.sendProspectBirthplace(this.selectedCity).then(() => {
      this.navigationService.nextStep('200');
    }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  /**
   * Summary Set propertys to Live Abroad
   * @param event
   */
  radioButtonChange(event: any) {
    const radio = this.checkboxList.find(e => e.value === event.value);
    if (!radio) { return; }
    this.abreCuentasService.setLiveAbroad({
      value: radio.label,
      elementId: parseInt(radio.value, 10),
      checked: true,
    });
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOption(event) {
    if (event.value) {
      this.selectedCity = this.options.find(e => (e.city_code === event.value.city_code) &&
        (e.province_code === event.value.province_code)) || this.emptyCity;
      this.selectedCity.bp_city_code = this.selectedCity.city_code;
      this.selectedCity.bp_province_code = this.selectedCity.province_code;
      this.abreCuentasService.setBirthplaceInfo(this.selectedCity);
      this.enableButton();
      return;
    }
    this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
    this.enableButton();
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOptions(event) {
    if (event.value) {
      this.selectedEthnicGroup.ethnic_group_code = event.value.id;
      this.selectedEthnicGroup.ethnic_group_description = event.value.value;
      this.abreCuentasService.setEthnicGroupInfo(this.selectedEthnicGroup);
    }
  }
  // TODO: SETEO DE contactInfo
  setContactInfo(data) {
    const contactInfo = data;
    this.contactInfo = new ContactModel();
    this.contactInfo.email = contactInfo.email;
    this.contactInfo.mobile_number = contactInfo.mobile_number;
    this.abreCuentasService.setContactInfo(this.contactInfo);
    // TODO: AGREGAR CONDICION PARA QUE SOLO EN CUENTA NOMINA SE EJECUTE EL SERVICIO
    const product = this.abreCuentasService.getproductSelected();
    if (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL) {
      this.setDataProspectOccupation();
    }
  }

  // TODO: SETEO DE PROSPECT OCUPATION
  setDataProspectOccupation() {
    this.abreCuentasService.setOccupationSelected(this.parametersService.getSetting(OpEnum.OCCUPATIONS_LIST)[0]);
    this.captureService.sendProspectOccupation().then(
      (res: any) => {
        if (!res) { return; }
        this.abreCuentasService.setinfoInferredIncomes(res.body.data);
      });
  }
  initBioCatch() {
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    console.log('PRODUCTO----', product);
    this.bioCatchService.changeContext(StepBiocatchEnum.captura, product);
  }

  sendTagging(value: any, position?: string, event?: string, extras?: any) {
    const page = '28';
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }

  async getCitys(provence_id: string) {
    await this.requestService.cityBranches(provence_id).then(responseR => {
      this.city_option = responseR.body;
      this.options = this.city_option.map(data => {
        const codeDaneResidence = data.code_dane;
        const codeDanelength = codeDaneResidence.length - 3;
        return {
          city_code: codeDaneResidence.substring(codeDanelength),
          province_code: +codeDaneResidence.substring(0, codeDanelength),
          description: data.city,
          district_id: data.district.district_id,
        };
      },
        );
    });
  }

  selectOptionProvidence(event) {
    const valueResidence: string = event.value;
    console.log(event);
    if (valueResidence && valueResidence.trim() !== '') {
      this.selected_district = valueResidence;
      this.getCitys(valueResidence);
    } else {
      this.city_option = undefined;
      this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
      this.selected_district = undefined;
    }
    this.enableButton();
  }

  enableButton() {
    if (this.selectedCity.city_code !== '' && this.selected_district !== undefined) {
      this.enabledButton = false;
    } else {
      this.enabledButton = true;
    }
  }
}
